import React from 'react';
import { User, UserPlus, UserCheck } from 'lucide-react';
import clsx from 'clsx';
import Button from './Button';
import styles from './RoleAssignmentCard.module.css';

export interface RoleAssignmentCardProps {
  title: string;
  currentAssignee?: string;
  currentAssigneeId?: number | null;
  description: string;
  buttonText: string;
  buttonIcon?: React.ReactNode;
  onAssign: () => void;
  canAssign?: boolean;
  className?: string;
}

const RoleAssignmentCard: React.FC<RoleAssignmentCardProps> = ({
  title,
  currentAssignee,
  currentAssigneeId,
  description,
  buttonText,
  buttonIcon,
  onAssign,
  canAssign = true,
  className = ''
}) => {
  const isAssigned = currentAssigneeId && currentAssignee;
  const displayName = currentAssignee || 'Unassigned';
  const role = title.split(' ').pop();

  return (
    <div className={clsx(styles.infoCard, className)}>
      <div className={styles.infoHeader}>
        <h3 className={styles.infoTitle}>
          <User size={18} />
          {title}
        </h3>
      </div>
      <div className={styles.infoContent}>
        <div className={styles.assignmentActions}>
          <div className={styles.assignmentInfo}>
            <div className={styles.currentAssignment}>
              <span className={styles.assignmentLabel}>Current {role}:</span>
              <span
                className={clsx(styles.assignmentValue, {
                  [styles.assignmentValueUnassigned]: !isAssigned
                })}
              >
                {displayName}
              </span>
            </div>
            <p className={styles.assignmentDescription}>{description}</p>
          </div>
          {canAssign && (
            <Button variant="primary" onClick={onAssign} className={styles.assignmentButton}>
              {buttonIcon ||
                (isAssigned ? (
                  <UserCheck size={16} className={styles.buttonIcon} />
                ) : (
                  <UserPlus size={16} className={styles.buttonIcon} />
                ))}
              {isAssigned ? `Reassign ${role}` : buttonText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RoleAssignmentCard;
